import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e675d19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "broll-view" }
const _hoisted_2 = { class: "broll-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "broll-title" }, "B-Roll Footage Request", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "broll-subtitle" }, " Content creators can request non-watermarked b-roll footage for use on their personal platforms. Fill out the form below and we'll review your request. ", -1))
const _hoisted_5 = {
  key: 0,
  class: "success-box"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "success-heading" }, "Request Submitted!", -1))
const _hoisted_7 = { class: "success-body" }
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Contact Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Social / Channel Links "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-hint" }, "Add links to the platforms where you create content.", -1))
const _hoisted_13 = {
  key: 0,
  class: "field-error"
}
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Requested Games "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-hint" }, "List the games you're requesting b-roll footage for.", -1))
const _hoisted_17 = {
  key: 0,
  class: "field-error"
}
const _hoisted_18 = {
  key: 0,
  class: "submit-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              color: "#4caf50",
              size: "52"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-check-circle-outline")
              ]),
              _: 1
            }),
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode("We'll review your request and get back to you at "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.form.email), 1),
              _createTextVNode(" within 14 days.")
            ]),
            _createVNode(_component_v_btn, {
              variant: "outlined",
              color: "warning",
              class: "mt-6",
              onClick: _ctx.resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit Another Request")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "broll-form",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                type: "email",
                placeholder: "your@email.com",
                variant: "outlined",
                density: "comfortable",
                "error-messages": _ctx.errors.email,
                class: "broll-input"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.socials, (social, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "social-row"
                }, [
                  _createVNode(_component_v_text_field, {
                    modelValue: social.platform,
                    "onUpdate:modelValue": ($event: any) => ((social.platform) = $event),
                    placeholder: "Platform (e.g. YouTube)",
                    variant: "outlined",
                    density: "comfortable",
                    class: "broll-input platform-field",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: social.url,
                    "onUpdate:modelValue": ($event: any) => ((social.url) = $event),
                    placeholder: "https://...",
                    variant: "outlined",
                    density: "comfortable",
                    class: "broll-input url-field",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    color: "error",
                    disabled: _ctx.form.socials.length === 1,
                    onClick: ($event: any) => (_ctx.removeSocial(index))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-close")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]))
              }), 128)),
              _createVNode(_component_v_btn, {
                variant: "tonal",
                size: "small",
                class: "add-btn",
                onClick: _ctx.addSocial
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "18"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-plus")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Add Link ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.errors.socials)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errors.socials), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.games, (game, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "game-row"
                }, [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.form.games[index],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.games[index]) = $event),
                    placeholder: "Game title",
                    variant: "outlined",
                    density: "comfortable",
                    class: "broll-input",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    color: "error",
                    disabled: _ctx.form.games.length === 1,
                    onClick: ($event: any) => (_ctx.removeGame(index))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-close")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]))
              }), 128)),
              _createVNode(_component_v_btn, {
                variant: "tonal",
                size: "small",
                class: "add-btn",
                onClick: _ctx.addGame
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "18"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-plus")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Add Game ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.errors.games)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errors.games), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.submitError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.submitError), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              type: "submit",
              color: "warning",
              loading: _ctx.loading,
              disabled: _ctx.loading,
              size: "large",
              class: "submit-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit Request ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ], 32))
    ])
  ]))
}